/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Zenith API
 * This site hosts documentation generated from the Zenith API OpenAPI specification.
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  RpcStatus,
  TeamsListMembersResponse,
  TeamsServiceAssignRolesBody,
  TeamsServiceCreateGroupBody,
  TeamsServiceInviteMemberBody,
  TeamsServiceListMembersParams,
  TeamsServiceRenameGroupBody,
  ZenithTeamsListTeamsResponse,
  ZenithTeamsTeam
} from '../model';

import { apiClient } from '../../lib/client';




/**
 * List teams the caller belongs to
 * @summary ListTeams
 */
export const teamsServiceListTeams = (

 signal?: AbortSignal
) => {


      return apiClient<ZenithTeamsListTeamsResponse>(
      {url: `/teams`, method: 'GET', signal
    },
      );
    }




export const getTeamsServiceListTeamsQueryKey = () => {
    return [
    'teams'
    ] as const;
    }


export const getTeamsServiceListTeamsQueryOptions = <TData = Awaited<ReturnType<typeof teamsServiceListTeams>>, TError = RpcStatus>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsServiceListTeams>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getTeamsServiceListTeamsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsServiceListTeams>>> = ({ signal }) => teamsServiceListTeams(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsServiceListTeams>>, TError, TData>
}

export type TeamsServiceListTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof teamsServiceListTeams>>>
export type TeamsServiceListTeamsQueryError = RpcStatus


/**
 * @summary ListTeams
 */

export function useTeamsServiceListTeams<TData = Awaited<ReturnType<typeof teamsServiceListTeams>>, TError = RpcStatus>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsServiceListTeams>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsServiceListTeamsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Get a team
 * @summary GetTeam
 */
export const teamsServiceGetTeam = (
    teamId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      teamId = toValue(teamId);

      return apiClient<ZenithTeamsTeam>(
      {url: `/teams/${teamId}`, method: 'GET', signal
    },
      );
    }




export const getTeamsServiceGetTeamQueryKey = (teamId: MaybeRefOrGetter<string>,) => {
    return [
    'teams',teamId
    ] as const;
    }


export const getTeamsServiceGetTeamQueryOptions = <TData = Awaited<ReturnType<typeof teamsServiceGetTeam>>, TError = RpcStatus>(teamId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsServiceGetTeam>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getTeamsServiceGetTeamQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsServiceGetTeam>>> = ({ signal }) => teamsServiceGetTeam(teamId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(teamId) !== null && toValue(teamId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsServiceGetTeam>>, TError, TData>
}

export type TeamsServiceGetTeamQueryResult = NonNullable<Awaited<ReturnType<typeof teamsServiceGetTeam>>>
export type TeamsServiceGetTeamQueryError = RpcStatus


/**
 * @summary GetTeam
 */

export function useTeamsServiceGetTeam<TData = Awaited<ReturnType<typeof teamsServiceGetTeam>>, TError = RpcStatus>(
 teamId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsServiceGetTeam>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsServiceGetTeamQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Add a group to a team
 * @summary CreateGroup
 */
export const teamsServiceCreateGroup = (
    teamId: MaybeRefOrGetter<string>,
    teamsServiceCreateGroupBody: MaybeRefOrGetter<TeamsServiceCreateGroupBody>,
 signal?: AbortSignal
) => {
      teamId = toValue(teamId);
teamsServiceCreateGroupBody = toValue(teamsServiceCreateGroupBody);

      return apiClient<ZenithTeamsTeam>(
      {url: `/teams/${teamId}/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: teamsServiceCreateGroupBody, signal
    },
      );
    }




export const getTeamsServiceCreateGroupMutationKey = () => ['teamsServiceCreateGroup'] as const;

export const getTeamsServiceCreateGroupMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsServiceCreateGroup>>, TError,TeamsServiceCreateGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsServiceCreateGroup>>, TError,TeamsServiceCreateGroupMutationVariables, TContext> => {

const mutationKey = getTeamsServiceCreateGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsServiceCreateGroup>>, TeamsServiceCreateGroupMutationVariables> = (props) => {
          const {teamId,data} = props ?? {};

          return  teamsServiceCreateGroup(teamId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeamsServiceCreateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof teamsServiceCreateGroup>>>
    export type TeamsServiceCreateGroupMutationBody = TeamsServiceCreateGroupBody
    export type TeamsServiceCreateGroupMutationError = RpcStatus
    export type TeamsServiceCreateGroupMutationVariables = {teamId: string;data: TeamsServiceCreateGroupBody}

    /**
 * @summary CreateGroup
 */
export const useTeamsServiceCreateGroup = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsServiceCreateGroup>>, TError,TeamsServiceCreateGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof teamsServiceCreateGroup>>,
        TError,
        TeamsServiceCreateGroupMutationVariables,
        TContext
      > => {
      return useMutation(getTeamsServiceCreateGroupMutationOptions(options), queryClient);
    }
    /**
 * Remove a group from a team
 * @summary RemoveGroup
 */
export const teamsServiceRemoveGroup = (
    teamId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      teamId = toValue(teamId);
groupId = toValue(groupId);

      return apiClient<ZenithTeamsTeam>(
      {url: `/teams/${teamId}/groups/${groupId}`, method: 'DELETE', signal
    },
      );
    }




export const getTeamsServiceRemoveGroupMutationKey = () => ['teamsServiceRemoveGroup'] as const;

export const getTeamsServiceRemoveGroupMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsServiceRemoveGroup>>, TError,TeamsServiceRemoveGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsServiceRemoveGroup>>, TError,TeamsServiceRemoveGroupMutationVariables, TContext> => {

const mutationKey = getTeamsServiceRemoveGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsServiceRemoveGroup>>, TeamsServiceRemoveGroupMutationVariables> = (props) => {
          const {teamId,groupId} = props ?? {};

          return  teamsServiceRemoveGroup(teamId,groupId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeamsServiceRemoveGroupMutationResult = NonNullable<Awaited<ReturnType<typeof teamsServiceRemoveGroup>>>

    export type TeamsServiceRemoveGroupMutationError = RpcStatus
    export type TeamsServiceRemoveGroupMutationVariables = {teamId: string;groupId: string}

    /**
 * @summary RemoveGroup
 */
export const useTeamsServiceRemoveGroup = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsServiceRemoveGroup>>, TError,TeamsServiceRemoveGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof teamsServiceRemoveGroup>>,
        TError,
        TeamsServiceRemoveGroupMutationVariables,
        TContext
      > => {
      return useMutation(getTeamsServiceRemoveGroupMutationOptions(options), queryClient);
    }
    /**
 * Rename a group in a team
 * @summary RenameGroup
 */
export const teamsServiceRenameGroup = (
    teamId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    teamsServiceRenameGroupBody: MaybeRefOrGetter<TeamsServiceRenameGroupBody>,
 signal?: AbortSignal
) => {
      teamId = toValue(teamId);
groupId = toValue(groupId);
teamsServiceRenameGroupBody = toValue(teamsServiceRenameGroupBody);

      return apiClient<ZenithTeamsTeam>(
      {url: `/teams/${teamId}/groups/${groupId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: teamsServiceRenameGroupBody, signal
    },
      );
    }




export const getTeamsServiceRenameGroupMutationKey = () => ['teamsServiceRenameGroup'] as const;

export const getTeamsServiceRenameGroupMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsServiceRenameGroup>>, TError,TeamsServiceRenameGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsServiceRenameGroup>>, TError,TeamsServiceRenameGroupMutationVariables, TContext> => {

const mutationKey = getTeamsServiceRenameGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsServiceRenameGroup>>, TeamsServiceRenameGroupMutationVariables> = (props) => {
          const {teamId,groupId,data} = props ?? {};

          return  teamsServiceRenameGroup(teamId,groupId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeamsServiceRenameGroupMutationResult = NonNullable<Awaited<ReturnType<typeof teamsServiceRenameGroup>>>
    export type TeamsServiceRenameGroupMutationBody = TeamsServiceRenameGroupBody
    export type TeamsServiceRenameGroupMutationError = RpcStatus
    export type TeamsServiceRenameGroupMutationVariables = {teamId: string;groupId: string;data: TeamsServiceRenameGroupBody}

    /**
 * @summary RenameGroup
 */
export const useTeamsServiceRenameGroup = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsServiceRenameGroup>>, TError,TeamsServiceRenameGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof teamsServiceRenameGroup>>,
        TError,
        TeamsServiceRenameGroupMutationVariables,
        TContext
      > => {
      return useMutation(getTeamsServiceRenameGroupMutationOptions(options), queryClient);
    }
    /**
 * List a team's members, paginated and optionally filtered by name/email query and role
 * @summary ListMembers
 */
export const teamsServiceListMembers = (
    teamId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<TeamsServiceListMembersParams>,
 signal?: AbortSignal
) => {
      teamId = toValue(teamId);
params = toValue(params);

      return apiClient<TeamsListMembersResponse>(
      {url: `/teams/${teamId}/members`, method: 'GET',
        params, signal
    },
      );
    }




export const getTeamsServiceListMembersQueryKey = (teamId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<TeamsServiceListMembersParams>,) => {
    return [
    'teams',teamId,'members', ...(params ? [params] : [])
    ] as const;
    }


export const getTeamsServiceListMembersQueryOptions = <TData = Awaited<ReturnType<typeof teamsServiceListMembers>>, TError = RpcStatus>(teamId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<TeamsServiceListMembersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsServiceListMembers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getTeamsServiceListMembersQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsServiceListMembers>>> = ({ signal }) => teamsServiceListMembers(teamId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(teamId) !== null && toValue(teamId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsServiceListMembers>>, TError, TData>
}

export type TeamsServiceListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof teamsServiceListMembers>>>
export type TeamsServiceListMembersQueryError = RpcStatus


/**
 * @summary ListMembers
 */

export function useTeamsServiceListMembers<TData = Awaited<ReturnType<typeof teamsServiceListMembers>>, TError = RpcStatus>(
 teamId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<TeamsServiceListMembersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsServiceListMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsServiceListMembersQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Invites a member to a team
 * @summary InviteMember
 */
export const teamsServiceInviteMember = (
    teamId: MaybeRefOrGetter<string>,
    teamsServiceInviteMemberBody: MaybeRefOrGetter<TeamsServiceInviteMemberBody>,
 signal?: AbortSignal
) => {
      teamId = toValue(teamId);
teamsServiceInviteMemberBody = toValue(teamsServiceInviteMemberBody);

      return apiClient<ZenithTeamsTeam>(
      {url: `/teams/${teamId}/members`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: teamsServiceInviteMemberBody, signal
    },
      );
    }




export const getTeamsServiceInviteMemberMutationKey = () => ['teamsServiceInviteMember'] as const;

export const getTeamsServiceInviteMemberMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsServiceInviteMember>>, TError,TeamsServiceInviteMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsServiceInviteMember>>, TError,TeamsServiceInviteMemberMutationVariables, TContext> => {

const mutationKey = getTeamsServiceInviteMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsServiceInviteMember>>, TeamsServiceInviteMemberMutationVariables> = (props) => {
          const {teamId,data} = props ?? {};

          return  teamsServiceInviteMember(teamId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeamsServiceInviteMemberMutationResult = NonNullable<Awaited<ReturnType<typeof teamsServiceInviteMember>>>
    export type TeamsServiceInviteMemberMutationBody = TeamsServiceInviteMemberBody
    export type TeamsServiceInviteMemberMutationError = RpcStatus
    export type TeamsServiceInviteMemberMutationVariables = {teamId: string;data: TeamsServiceInviteMemberBody}

    /**
 * @summary InviteMember
 */
export const useTeamsServiceInviteMember = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsServiceInviteMember>>, TError,TeamsServiceInviteMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof teamsServiceInviteMember>>,
        TError,
        TeamsServiceInviteMemberMutationVariables,
        TContext
      > => {
      return useMutation(getTeamsServiceInviteMemberMutationOptions(options), queryClient);
    }
    /**
 * Remove member from a team
 * @summary RemoveMember
 */
export const teamsServiceRemoveMember = (
    teamId: MaybeRefOrGetter<string>,
    memberId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      teamId = toValue(teamId);
memberId = toValue(memberId);

      return apiClient<ZenithTeamsTeam>(
      {url: `/teams/${teamId}/members/${memberId}`, method: 'DELETE', signal
    },
      );
    }




export const getTeamsServiceRemoveMemberMutationKey = () => ['teamsServiceRemoveMember'] as const;

export const getTeamsServiceRemoveMemberMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsServiceRemoveMember>>, TError,TeamsServiceRemoveMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsServiceRemoveMember>>, TError,TeamsServiceRemoveMemberMutationVariables, TContext> => {

const mutationKey = getTeamsServiceRemoveMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsServiceRemoveMember>>, TeamsServiceRemoveMemberMutationVariables> = (props) => {
          const {teamId,memberId} = props ?? {};

          return  teamsServiceRemoveMember(teamId,memberId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeamsServiceRemoveMemberMutationResult = NonNullable<Awaited<ReturnType<typeof teamsServiceRemoveMember>>>

    export type TeamsServiceRemoveMemberMutationError = RpcStatus
    export type TeamsServiceRemoveMemberMutationVariables = {teamId: string;memberId: string}

    /**
 * @summary RemoveMember
 */
export const useTeamsServiceRemoveMember = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsServiceRemoveMember>>, TError,TeamsServiceRemoveMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof teamsServiceRemoveMember>>,
        TError,
        TeamsServiceRemoveMemberMutationVariables,
        TContext
      > => {
      return useMutation(getTeamsServiceRemoveMemberMutationOptions(options), queryClient);
    }
    /**
 * Replace a member's role set
 * @summary AssignRoles
 */
export const teamsServiceAssignRoles = (
    teamId: MaybeRefOrGetter<string>,
    memberId: MaybeRefOrGetter<string>,
    teamsServiceAssignRolesBody: MaybeRefOrGetter<TeamsServiceAssignRolesBody>,
 signal?: AbortSignal
) => {
      teamId = toValue(teamId);
memberId = toValue(memberId);
teamsServiceAssignRolesBody = toValue(teamsServiceAssignRolesBody);

      return apiClient<ZenithTeamsTeam>(
      {url: `/teams/${teamId}/members/${memberId}/roles`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: teamsServiceAssignRolesBody, signal
    },
      );
    }




export const getTeamsServiceAssignRolesMutationKey = () => ['teamsServiceAssignRoles'] as const;

export const getTeamsServiceAssignRolesMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsServiceAssignRoles>>, TError,TeamsServiceAssignRolesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsServiceAssignRoles>>, TError,TeamsServiceAssignRolesMutationVariables, TContext> => {

const mutationKey = getTeamsServiceAssignRolesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsServiceAssignRoles>>, TeamsServiceAssignRolesMutationVariables> = (props) => {
          const {teamId,memberId,data} = props ?? {};

          return  teamsServiceAssignRoles(teamId,memberId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TeamsServiceAssignRolesMutationResult = NonNullable<Awaited<ReturnType<typeof teamsServiceAssignRoles>>>
    export type TeamsServiceAssignRolesMutationBody = TeamsServiceAssignRolesBody
    export type TeamsServiceAssignRolesMutationError = RpcStatus
    export type TeamsServiceAssignRolesMutationVariables = {teamId: string;memberId: string;data: TeamsServiceAssignRolesBody}

    /**
 * @summary AssignRoles
 */
export const useTeamsServiceAssignRoles = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsServiceAssignRoles>>, TError,TeamsServiceAssignRolesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof teamsServiceAssignRoles>>,
        TError,
        TeamsServiceAssignRolesMutationVariables,
        TContext
      > => {
      return useMutation(getTeamsServiceAssignRolesMutationOptions(options), queryClient);
    }
